<div class="gmap h-100" #gmap></div>

<div class="flex flex-col absolute text-lg ml-3  font-semibold tracking-tight leading-8">Mappa {{posizione.codice_interno}}</div>

<div class="flex flex-col absolute ml-3 mt-8 bg-white  p-1 rounded-md shadow-md"
(mouseover)="over()"
(mouseout)="out()"
>
    <button mat-raised-button color="primary" (click)="setEditMode()">
        <mat-icon svgIcon="heroicons_outline:square-3-stack-3d"></mat-icon>
    </button>
</div>


<div id="layerController" #layers class="flex flex-col absolute ml-3 mt-8 bg-white  p-2 rounded-md shadow-md" [ngClass]="{'hidden': status=='out'}"
(mouseover)="over()"
(mouseout)="out()"

>
    <div class="flex font-semibold">Basi</div>
    <ng-container *ngFor="let base of BaseMaps">
        <div>
            <input type="radio"  [(ngModel)]="baseMap" [value]="base.id" (change)="setBaseMap(base.id)">
            <label class="ml-2" >{{base.title}}</label>
        </div>
    </ng-container>

    <div class="flex font-semibold">Livelli</div>
    <ng-container *ngFor="let overlay of wmsLayers">
        <div class=" flex items-center gap-3">
            <input type="checkbox" [(ngModel)]="layerStatus[overlay.id]" (ngModelChange)="setOverlay()">
            <label for="toggleTraffic">{{overlay.title}}</label>
        </div>
    </ng-container>


</div>


<div #gpano class="gpano h-100"></div>



<div *ngIf="!editMode"  class="flex absolute bottom-3 ml-3 bg-white text-lg font-bold p-1 rounded-md shadow-md">
    <button mat-raised-button color="primary" (click)="setEditMode()">
        <mat-icon  svgIcon="heroicons_outline:pencil-square"></mat-icon>
    </button>
</div>


<div *ngIf="editMode"  class="flex absolute bottom-3 ml-3 bg-white text-lg font-bold p-1 rounded-md shadow-md">
    <button class="p-1" mat-raised-button color="primary" (click)="cancelPosition()">
        <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
    </button>

    <span class="p-1">{{marker.getPosition().lat() | number: '2.5'}}</span>
    <span class="p-1">{{marker.getPosition().lng() | number: '1.5'}}</span>
    <button class="p-1" mat-raised-button color="primary" (click)="savePosition()">
        <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
    </button>

</div>

